<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="27.997" height="32" viewBox="0 0 27.997 32">
    <path d="M28.127,13.123a13.131,13.131,0,0,1-7.675-2.454V21.842a10.161,10.161,0,1,1-8.766-10.069v5.62a4.665,4.665,0,1,0,3.265,4.45V0h5.5a7.574,7.574,0,0,0,.116,1.386h0A7.638,7.638,0,0,0,23.939,6.4,7.59,7.59,0,0,0,28.127,7.66Z" transform="translate(-0.13)" class="fill-current"/>
  </svg>  
</template>
